<ng-container>
  <textarea
    [disabled]="disabled"
    [(ngModel)]="note.text"
    [name]="name"
    (focusout)="onFocusOut()"
  ></textarea>
</ng-container>
